import { useState, useCallback } from 'react';
import { api } from '@/lib/api';

export function useSurvey(surveyType: string) {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = useCallback(
    async (value: unknown, textValue?: string) => {
      setLoading(true);
      try {
        await api.post('/analytics/surveys', { surveyType, value, textValue });
        setSubmitted(true);
      } catch {
        // Silent fail for surveys
      } finally {
        setLoading(false);
      }
    },
    [surveyType],
  );

  return { submit, loading, submitted };
}
